import React from "react";
import { iconProps } from "../../Helper";

export const ImageLibraryIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.1391 3.42969C13.6565 3.75828 14.0001 4.33734 14.0001 4.99665V10.9967C14.0001 12.6535 12.6569 13.9967 11.0001 13.9967H5.00007C4.34076 13.9967 3.7617 13.6531 3.43214 13.1352L3.50194 13.1385L3.5715 13.1395H11.0001C12.1835 13.1395 13.1429 12.1801 13.1429 10.9967V3.56808C13.1429 3.52164 13.1416 3.4755 13.1391 3.42969ZM10.7144 1.71094C11.74 1.71094 12.5715 2.54241 12.5715 3.56808V10.7109C12.5715 11.7366 11.74 12.5681 10.7144 12.5681H3.5715C2.54583 12.5681 1.71436 11.7366 1.71436 10.7109V3.56808C1.71436 2.54241 2.54583 1.71094 3.5715 1.71094H10.7144ZM11.0467 11.6544L7.44269 8.12415C7.29121 7.97579 7.05718 7.96231 6.8907 8.08369L6.84293 8.12415L3.23918 11.6544C3.34316 11.691 3.455 11.7109 3.5715 11.7109H10.7144C10.8309 11.7109 10.9427 11.691 11.0467 11.6544ZM10.7144 2.56808H3.5715C3.01921 2.56808 2.5715 3.0158 2.5715 3.56808V10.7109C2.5715 10.8298 2.59224 10.9438 2.6303 11.0496L6.24317 7.51179C6.71922 7.04554 7.46712 7.02333 7.96906 7.44518L8.04244 7.51179L11.6553 11.0502C11.6935 10.9442 11.7144 10.83 11.7144 10.7109V3.56808C11.7144 3.0158 11.2666 2.56808 10.7144 2.56808ZM9.14318 4.42589C9.53745 4.42589 9.85706 4.7455 9.85706 5.13977C9.85706 5.53403 9.53745 5.85364 9.14318 5.85364C8.74892 5.85364 8.4293 5.53403 8.4293 5.13977C8.4293 4.7455 8.74892 4.42589 9.14318 4.42589Z"
        className={className}
      />
    </svg>
  );
};
